import { Contributor, Shared } from "components/workflow/steps";
import { IFeedback, IPotluck, IUser } from "interfaces";

export const Steps = [
  Contributor.Details.default,
  Shared.Guest.default,
  Contributor.Voting.default,
  Shared.Feedback.default,
];

export type ContributorType = { potluck: IPotluck, user: IUser, feedback: IFeedback };